module.exports = __webpack_public_path__ + "static/media/hamburger-menu.058253fd.svg";